import { fromUndefinedToNull, isEmptyString, isObject } from '@vy/utils';
import type React from 'react';

export function handleNumericTextFieldChange(onChange: (newValue: number | string) => void) {
  return (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    if (isEmptyString(event.target.value)) {
      onChange('');

      return;
    }

    const value = Number(event.target.value);
    onChange(value);
  };
}

export function getDirtyValues<
  DirtyFields extends Record<string, unknown>,
  Values extends Record<keyof DirtyFields, unknown>,
>(dirtyFields: DirtyFields, values: Values): Partial<typeof values> {
  const dirtyValues = Object.keys(dirtyFields).reduce((prev, key) => {
    if (!dirtyFields[key]) {
      return prev;
    }

    return {
      ...prev,
      [key]: isObject(dirtyFields[key]) ? values[key] : fromUndefinedToNull(values[key]),
    };
  }, {});

  return dirtyValues;
}
